import type { BranchPanelSnapshot, OwnerPanelAlert } from '../domain/types';

const SEVERITY_RANK: Record<OwnerPanelAlert['severity'], number> = {
  warn: 0,
  info: 1,
};

export function buildOwnerPanelAlerts(snapshots: BranchPanelSnapshot[]): OwnerPanelAlert[] {
  const alerts: OwnerPanelAlert[] = [];

  for (const snap of snapshots) {
    const { branch } = snap;
    if (!snap.loaded) continue;

    // #1468: "Caja cerrada" no es alerta — es un estado operativo normal
    // (fuera de horario) y ya se muestra neutro en la card de la sucursal.
    // Las alertas son solo lo que pide acción: pedidos sin atender, stock bajo,
    // local sin ubicar en el mapa.

    if ((snap.pendingOrders ?? 0) > 0) {
      alerts.push({
        id: `${branch.id}:pending-orders`,
        severity: 'warn',
        branchId: branch.id,
        branchName: branch.name,
        message: `${snap.pendingOrders} pedido${snap.pendingOrders === 1 ? '' : 's'} sin atender`,
      });
    }

    if ((snap.lowStockCount ?? 0) > 0) {
      alerts.push({
        id: `${branch.id}:low-stock`,
        severity: 'info',
        branchId: branch.id,
        branchName: branch.name,
        message: `${snap.lowStockCount} producto${snap.lowStockCount === 1 ? '' : 's'} con stock bajo`,
      });
    }

    if (snap.missingMap) {
      alerts.push({
        id: `${branch.id}:missing-map`,
        severity: 'info',
        branchId: branch.id,
        branchName: branch.name,
        message: 'Falta ubicar el local en el mapa',
      });
    }
  }

  return alerts.sort((a, b) => {
    const bySeverity = SEVERITY_RANK[a.severity] - SEVERITY_RANK[b.severity];
    if (bySeverity !== 0) return bySeverity;
    return a.branchName.localeCompare(b.branchName, 'es');
  });
}
